import React, { useEffect } from "react";
import logo from "./bluelogo.png";
import './FreeTensesExercises.css'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import FreeTensesPdf from './freetrial__videos/all irregular verbs.pdf'
function FreeTensesExercises() {
    useEffect(() => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
      }, []);
      useEffect(() => {
        const header = document.getElementById("All__courses__header");
        const headerLogo = document.querySelector("#All__courses__header a img");
    
        if (window.scrollY > 50) {
          // Change 30 to your desired scroll distance
    
          headerLogo.style.width = "60px";
          header.style.padding = "10px 100px";
          header.style.transition = "background 0.3s ease-in-out";
        } else {
          if (window.innerWidth < "668") {
            headerLogo.style.width = "60px";
            header.style.background = "white";
            header.style.padding = "20px 100px";
          } else {
            headerLogo.style.width = "60px";
            header.style.background = "white";
          }
        }
      }, []);
      window.onscroll = function () {
        const header = document.getElementById("All__courses__header");
        const headerLogo = document.querySelector("#All__courses__header >a> img");
    
        if (window.scrollY > 50) {
          // Change 30 to your desired scroll distance
    
          headerLogo.style.width = "60px";
          header.style.padding = "10px 100px";
          header.style.transition = "background 0.3s ease-in-out";
        } else {
          if (window.innerWidth < "668") {
            headerLogo.style.width = "60px";
            header.style.background = "white";
            header.style.padding = "20px 100px";
          } else {
            headerLogo.style.width = "60px";
            header.style.background = "white";
          }
        }
      };
      function scrollToTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
   

  return <div>
     <header id="All__courses__header" className="freetrial__videos__header">
        <a href="https://toustousacademy.com/">
          <img className="functions__logo" src={logo} alt="" />
        </a>
        <ul>
          <a href="/">
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      {/* <iframe className="irr__pdf" src={FreeTensesPdf} frameborder="0"></iframe>  */}
      <div className="downloadSection">
        <a
          id="download__tenses__exercises"
          
          href={FreeTensesPdf}
          download
          onClick={(e) => e.stopPropagation()}
        >

          Download PDF
          <CloudDownloadIcon className="download__icon"/>
          {/* <span className="tp-playBtnChev">›</span> */}
        </a>
      </div>

    
     
  </div>;
}

export default FreeTensesExercises;
